function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 16px 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  text-align: right;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import BackButton from "../../../back-button";
import Button from "../../../button";
import GenerateProposalDropdown from "../../../generate-proposal-dropdown";
import { Formik } from "formik";
import { WrCol as Col, WrRow as Row } from "../../../grid";
import { context } from "../../../wr-context";
import { useProvidedBuilder } from "../DocumentEditorWrapper";
import styled from "styled-components";
export var DocumentEditorToolbar = function(param) {
    var _BackButton = param.BackButton, BackButton = _BackButton === void 0 ? DefaultBackButton : _BackButton, _ChangeLogButton = param.ChangeLogButton, ChangeLogButton = _ChangeLogButton === void 0 ? DefaultChangeLogButton : _ChangeLogButton, _SubmitButton = param.SubmitButton, SubmitButton = _SubmitButton === void 0 ? DefaultSubmitButton : _SubmitButton, enableChangeLog = param.enableChangeLog, _options = param.options, options = _options === void 0 ? {} : _options;
    var builder = useProvidedBuilder();
    return /*#__PURE__*/ React.createElement(Wrapper, null, /*#__PURE__*/ React.createElement(Row, {
        middle: "xs"
    }, /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement(BackButton, {
        builder: builder,
        options: options
    })), /*#__PURE__*/ React.createElement(Col, {
        xs: true
    }), Boolean(enableChangeLog) && /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement(ChangeLogButton, {
        builder: builder,
        options: options
    })), /*#__PURE__*/ React.createElement(Col, {
        xs: true,
        $noGrow: true
    }, /*#__PURE__*/ React.createElement(SubmitWrapper, null, /*#__PURE__*/ React.createElement(SubmitButton, {
        builder: builder,
        options: options
    })))));
};
var DefaultBackButton = function() {
    return /*#__PURE__*/ React.createElement(BackButton, null);
};
var DefaultChangeLogButton = function(param) {
    var builder = param.builder;
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: function() {
            return builder.setView(builder.view === "default" ? "changeLog" : "default");
        }
    }, builder.view === "default" ? "Changelog" : "Edit SOW");
};
var DefaultSubmitButton = function(param) {
    var builder = param.builder, options = param.options;
    return /*#__PURE__*/ React.createElement(Formik, _extends({}, {}), /*#__PURE__*/ React.createElement(GenerateProposalDropdown, {
        theme: context.theme.components.dropdown.color,
        // For some reason need this to make `asDraft` work
        isLoggedIn: true,
        options: options.submitOptions || {
            asPdf: true,
            asDoc: true,
            asDraft: false
        },
        onChange: function(format) {
            var typesMap = {
                asQuotePdf: "pdf",
                asPdf: "pdf",
                asQuoteWord: "docx",
                asWord: "docx",
                asDraft: "draft"
            };
            var type = typesMap[format];
            builder.submit({
                type: type
            });
        },
        disabled: builder.isLoading
    }));
};
var Wrapper = styled.div(_templateObject());
var SubmitWrapper = styled.div(_templateObject1());
